export function loadFailMessage(fieldName) {
    const f = String(fieldName || "Field").trim() || "Field";
    return `The ${f} data load failed, Please reload the page and if the issue persist please contact system admin`;
}

export function loadOngoingMessage(fieldName) {
    const f = String(fieldName || "Field").trim() || "Field";
    return `The ${f} data load is ongoing please wait`;
}

export function loadTimeoutMessage(fieldName) {
    const f = String(fieldName || "Field").trim() || "Field";
    return `The ${f} data load taking too much time to load, Please wait or reload the page and if the issue persist please contact system admin`;
}

function slugifyToastIdPart(s) {
    return String(s || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "")
        .slice(0, 80);
}

export function dataLoadToastId(status, fieldName) {
    const st = slugifyToastIdPart(status || "status") || "status";
    const f = slugifyToastIdPart(fieldName || "field") || "field";
    return `npw:data-load:${st}:${f}`;
}

function getStartedAtMs(v) {
    const n = v?.startedAt ?? v?.startAt ?? v?.started_at ?? v?.at ?? null;
    return typeof n === "number" && isFinite(n) ? n : null;
}

export function isDataLoadTimedOut(v, timeoutMs = 20000, nowMs = Date.now()) {
    if (v?.status !== "loading") return false;
    const startedAt = getStartedAtMs(v);
    if (!startedAt) return false;
    return nowMs - startedAt >= timeoutMs;
}

/**
 * dataLoads shape: { [key: string]: { field: string, status: 'idle'|'loading'|'success'|'error', startedAt?: number } }
 */
export function firstBlockingDataLoad(dataLoads, opts = {}) {
    const nowMs = typeof opts.nowMs === "number" ? opts.nowMs : Date.now();
    const timeoutMs = typeof opts.timeoutMs === "number" ? opts.timeoutMs : 20000;

    const values = Object.values(dataLoads || {});
    const err = values.find((v) => v?.status === "error" && v?.field);
    if (err) return { status: "error", field: err.field };
    const timedOut = values.find((v) => v?.status === "loading" && v?.field && isDataLoadTimedOut(v, timeoutMs, nowMs));
    if (timedOut) return { status: "timeout", field: timedOut.field };
    const loading = values.find((v) => v?.status === "loading" && v?.field);
    if (loading) return { status: "loading", field: loading.field };
    return null;
}

/**
 * Returns all blocking loads, preserving object key order.
 * - error always blocks
 * - loading blocks; becomes 'timeout' after timeoutMs
 */
export function blockingLoadsForContinue(dataLoads, opts = {}) {
    const nowMs = typeof opts.nowMs === "number" ? opts.nowMs : Date.now();
    const timeoutMs = typeof opts.timeoutMs === "number" ? opts.timeoutMs : 20000;

    const result = [];
    const obj = dataLoads || {};
    for (const key of Object.keys(obj)) {
        const v = obj[key];
        if (!v?.field) continue;
        if (v.status === "error") {
            result.push({ status: "error", field: v.field });
            continue;
        }
        if (v.status === "loading") {
            result.push({ status: isDataLoadTimedOut(v, timeoutMs, nowMs) ? "timeout" : "loading", field: v.field });
        }
    }
    return result;
}

/**
 * Returns all blocking loads of a given status, preserving object key order.
 */
export function blockingDataLoads(dataLoads, status) {
    const st = status === "error" || status === "loading" ? status : null;
    if (!st) return [];

    const result = [];
    const obj = dataLoads || {};
    for (const key of Object.keys(obj)) {
        const v = obj[key];
        if (v?.status === st && v?.field) {
            result.push({ status: st, field: v.field });
        }
    }
    return result;
}
